import { make } from './Action'
import Constants from './Constants'
import NotifyActions from './NotifyActions'

const GET_DEVICE = 'GET_DEVICE';
const GET_DEVICES = 'GET_DEVICES';
const DEVICE_ERROR = 'DEVICE_ERROR'
const DEVICES_ERROR = 'DEVICES_ERROR'

const ADD_DEVICE = 'ADD_DEVICE';
const UPDATE_DEVICE = 'UPDATE_DEVICE';
const REMOVE_DEVICE = 'REMOVE_DEVICE';
const PAUSE_DEVICE = 'PAUSE_DEVICE';
const SET_DEVICE_UPDATER = 'SET_DEVICE_UPDATER';
const GET_DEVICE_UPDATERS = 'GET_DEVICE_UPDATERS';

const GET_DEVICE_BLUEPRINT = 'GET_DEVICE_BLUEPRINT'
const LOADING_DEVICE_BLUEPRINT = 'LOADING_DEVICE_BLUEPRINT'
const DEVICE_BLUEPRINT_ERROR = 'DEVICE_BLUEPRINT_ERROR'

export function getDevices( systemId, options ) {
  return function( dispatch, getState, api ) {

    dispatch( { type : Constants.GET_DEVICES_STATUS, status : Constants.STATUS_LOADING, statusMessage : null } )

    let sSystem = null;

    const loadSystem = api.getSystem( systemId )
    const loadDevices = api.getDevices( systemId, options );
    return loadSystem.then( ( system ) => {
      sSystem = system;
      return loadDevices
    } ).then( ( devices ) => {

      dispatch( {
        type : Constants.GET_DEVICES,
        system : sSystem,
        systemId : sSystem.id,
        startIndex : devices.startIndex,
        total : devices.total,
        perPage : devices.perPage, 
        items : devices.items,
        search : devices.search
      } )

      // dispatch( _getDevices( sSystem, devices ))
    } ).catch( ( ex ) => {
      const msg = ( ex.body && ex.body.message ) || ex.statusText
      dispatch( NotifyActions.requestError( 'Failed to get get devices', ex ) )
      dispatch( { type : Constants.GET_DEVICES_STATUS, status : Constants.STATUS_ERROR, statusMessage : msg } )
    } )
  }
}

// export function  getDevices( systemId, options ) {
//   return function( dispatch, getState, api ) {

//     return api.getDevices( systemId, options )
//       .then( devices => {
//         dispatch( _getDevices( systemId, devices ))
//       })
//       .catch( ex => {
//         let res = ex.response;
//         if ( res ) {
//           let msg = ( ex.body && ex.body.message ) || ex.statusText;
//           console.log( "ERROR in getDevices", ex, ex.body, res );
//           dispatch( _devicesError( systemId, res.status, msg ))
//         } else {
//           console.log( "ERROR dispatching getDevices", ex );
//         }
//       })
//    };
// }

function _getDevice( device ) {
  return { 
    type : GET_DEVICE,
    device
  };
}

function _deviceError( deviceId, status, msg ) {
  return { 
    type : DEVICE_ERROR,
    deviceId,
    status,
    message : msg
  };
}

export function getDevice( systemId, deviceId ) {
  return function( dispatch, getState, api ) {

    return api.getDevice( systemId, deviceId )
      .then( ( device ) => {
        dispatch( _getDevice( device ) )
        return device
      } )
      .catch( ( ex ) => {
        const res = ex.response;
        if ( res ) {
          const msg = ( ex.body && ex.body.message ) || ex.statusText;
          console.log( 'ERROR in getDevice', ex, ex.body, res );
          dispatch( _deviceError( deviceId, res.status, msg ) )
        } else {
          console.log( 'ERROR dispatching getDevice', ex );
        }
      } )
  };
}

function _addDevice( device ) {
  return { 
    type : ADD_DEVICE,
    device
  };
}

export function addDevice( systemId, device, options ) {

  return function( dispatch, getState, api ) {
    return api.system( systemId ).devices().create( device, { refresh : 'wait_for' } )
      .then( ( deviceData ) => {
        if ( options ) {
          return api.getDevice( systemId, deviceData.id, options )
        } 
        return deviceData
        
      } )
      .then( ( deviceData ) => {
        dispatch( _addDevice( deviceData ) )
        dispatch( NotifyActions.success( 'Device added' ) )
      } )
      .catch( ( ex ) => {
        console.log( 'ERROR in addDevice', ex );
        dispatch( NotifyActions.error( 'Error adding Device', ex.message ) )
      } )
  };
}

export function removeDevice( device ) {
  return function( dispatch, getState, api ) {
    return api.removeDevice( device )
      .then( ( deviceData ) => {
        dispatch( _removeDevice( device ) )
        dispatch( NotifyActions.success( 'Device successfuly deleted' ) )
      } )
      .catch( ( ex ) => {
        console.log( 'ERROR in removeDevice', ex );
      } )
  };
}

function _removeDevice( device ) {
  return {
    type : REMOVE_DEVICE,
    device
  };
}

/**
 * resetDevice( device )
 **/
const resetDevice = make( 'resetDevice', Constants.UPDATE_DEVICE, 'device', { msg : 'Failed to rest device', warning : true } )

// function resetDevice( device ) {
//   return function( dispatch, getState, api ) {

//     return api.resetDevice( device )
//       .then( deviceData => {
//         dispatch( {type : UPDATE_DEVICE, device: deviceData } )
//       })
//       .catch( ex => {
//         console.log( "ERROR in resetDevice", ex );
//       })
//   }

// }

/**
 * updateDevice( device, update )
 **/
const updateDevice = make( 'updateDevice', Constants.UPDATE_DEVICE, 'device', { msg : 'Failed to update device',
                                                                                warning : true, 
                                                                                callback( ex, dispatch ) { dispatch( { type : UPDATE_DEVICE } ) } } )

// et updateDevice = make( 'updateDevice', )

// export function updateDevice( device, data ) {
//   return function( dispatch, getState, api ) {

//     return api.updateDevice( device, data )
//       .then( deviceData => {
//         dispatch( {type : UPDATE_DEVICE, device: deviceData } )
//       })
//       .catch( ex => {
//         dispatch( {type : UPDATE_DEVICE } )
//         dispatch( NotifyActions.requestWarn( 'Unable to update device', ex ) )
//         console.log( "ERROR in updateDevice", ex )
//       })
//   };
// }

function _pauseDevice( device ) {
  return {
    type : PAUSE_DEVICE,
    device
  };
}

export function pauseDevice( device ) {
  return function( dispatch, getState, api ) {

    return api.pauseDevice( device )
      .then( ( data ) => {
        console.log( 'paused: ', data );
        dispatch( _pauseDevice( data ) )
      } )
      .catch( ( ex ) => {
        console.log( 'ERROR in pauseDevice', ex );
      } )
  };
}

function _startDevice( device ) {
  return {
    type : PAUSE_DEVICE,
    device
  };
}

export function startDevice( device ) {
  return function( dispatch, getState, api ) {

    return api.startDevice( device )
      .then( ( data ) => {
        console.log( 'started: ', data );
        dispatch( _startDevice( data ) )
      } )
      .catch( ( ex ) => {
        console.log( 'ERROR in startDevice', ex );
      } )
  };
}

export function logDevice( device ) {
  return function( dispatch, getState, api ) {

    return api.deviceLog( device )
      .then( ( data ) => {
        console.log( 'log: ', data );
      } )
      .catch( ( ex ) => {
        console.log( 'ERROR in logDevice', ex );
      } )
  };
}

function _getDeviceBlueprint( system, device, blueprint ) {
  return {
    type : GET_DEVICE_BLUEPRINT,
    system, 
    device,
    blueprint
  }
}

function _loadingDeviceBlueprint( device, blueprint ) {
  return {
    type : LOADING_DEVICE_BLUEPRINT
  }
}

function _deviceBlueprintError( err ) {
  return {
    type : DEVICE_BLUEPRINT_ERROR
  }
}

export function getDeviceBlueprint( systemId, deviceId ) {
  return function( dispatch, getState, api ) {
    dispatch( _loadingDeviceBlueprint( ) )

    let sSystem = null, dDevice = null
    const loadSystem = api.getSystem( systemId )
    const loadDevice = api.getDevice( systemId, deviceId, { blueprint : true, accessToken : true } )
    return loadSystem.then( ( system ) => {
      sSystem = system;
      return loadDevice
    } ).then( ( device ) => {
      dDevice = device
      return api.getBlueprint( device.projectId, device.blueprintId, { children : [ 'attribute', 'alert' ], attribute : { perPage : 10000 } } )
    } ).then( ( blueprint ) => {
      dispatch( _getDeviceBlueprint( sSystem, dDevice, blueprint ) )
    } ).catch( ( ex ) => {
      console.log( 'ERROR in getDeviceBlueprint', ex );
      dispatch( _deviceBlueprintError( ex ) );
    } );
  }
}
// export function getDeviceBlueprint( systemId, deviceId ) {
//   return function( dispatch, getState, api ) {
//     dispatch( _loadingDeviceBlueprint( ))
//     return api.getDevice( systemId, deviceId, { blueprint:true, accessToken : true } )
//       .then( device => {
//           dispatch( _getDeviceBlueprint( device, device.blueprint ))

//       }).catch( ex => {
//         console.log( "ERROR in getDeviceBlueprint", ex );
//         dispatch( _deviceBlueprintError( ex ));
//       });
//   }
// }

function _setDeviceUpdater( device, path, updater ) {
  return { 
    type : SET_DEVICE_UPDATER,
    deviceId : device.id,
    path,
    updater
  }
}

function setDeviceUpdater( device, path, updater ) {
  return function( dispatch, getState, api ) {
    console.log( 'Device', device )
    return api.setDeviceUpdater( device, path, updater )
      .then( ( result ) => {
        console.log( 'setDeviceUpdater result', result )
        dispatch( _setDeviceUpdater( device, path, updater ) )

      } ).catch( ( ex ) => {
        console.log( 'ERROR in getDeviceBlueprint', ex );
        dispatch( _deviceBlueprintError( ex ) );
      } );
  }
}

function _getDeviceUpdaters( device, path, updater ) {
  return { 
    type : GET_DEVICE_UPDATERS,
    deviceId,
    path,
    updater
  }
}

function getDeviceUpdaters( device, optPath ) {
  return function( dispatch, getState, api ) {
    dispatch( _loadingDeviceBlueprint( ) )
    return api.getDeviceUpdaters( device )
      .then( ( device ) => {
        dispatch( _getDeviceUpdaters( device, path, updater ) )

      } ).catch( ( ex ) => {
        console.log( 'ERROR in getDeviceBlueprint', ex );
        dispatch( _deviceBlueprintError( ex ) );
      } );
  }
}

module.exports = {
  GET_DEVICES,
  GET_DEVICE, 
  DEVICE_ERROR,
  DEVICES_ERROR,
  ADD_DEVICE,
  UPDATE_DEVICE,
  REMOVE_DEVICE,
  PAUSE_DEVICE, 
  SET_DEVICE_UPDATER,
  GET_DEVICE_UPDATERS,

  GET_DEVICE_BLUEPRINT,
  LOADING_DEVICE_BLUEPRINT,
  DEVICE_BLUEPRINT_ERROR,

  getDevices,
  getDevice,
  addDevice,
  updateDevice,
  startDevice,
  pauseDevice,
  resetDevice,
  removeDevice,
  logDevice,
  getDeviceBlueprint,

  setDeviceUpdater
}
